export const COLUMNS = {
  VIN: 'vin',
  EXPIRATION_DATE: 'expiration_date',
  MAKE: 'make',
  MODEL: 'model',
  TRIM: 'trim_level',
  STATUS: 'status',
  STOCK_NUMBER: 'stock_number',
  CONDITION: 'condition',
  COLOR: 'color',
  YEAR: 'year',
  MILEAGE: 'mileage',
  PRICE: 'sale_price',
  COST: 'internal_cost_price',
  REGISTRATION_PLATE_NUMBER: 'registration_plate_number',
  INTEGRATION_ID: 'integration_id',
  ALLIANCES_CAN_SEE: 'alliances_can_see',
  VISIBILITY: 'visibility',
  COLOR_INT: 'color_int',
  RECEPTION_DATE: 'reception_date',
  IS_TITLE_IN_DEALER: 'is_title_in_dealer',
  TAG_NUMBER: 'tag_number',
  TAG_NUMBER_EXPIRATION_DATE: 'tag_number_expiration_date',
  IS_TUNE_UP: 'is_tune_up',
  FEATURED: 'featured',
  DEALER: 'dealer',
  PLEDGED: 'pledged',
  LOCATION: 'location',
  AGE: 'age',
  IMPRESSIONS: 'impressions_count',
  NOTES: 'notes',
};

export default COLUMNS;
